import { EntityDoc } from "../../entity/EntityDoc";

export class DtoDocsPutRes extends EntityDoc {}
